var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMWhiteLogoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 472,
    viewBox: "0 0 472 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.316 111.789H384.6L298.756 160.231H245.316C227.014 160.231 201.104 163.269 187.149 171.506C173.194 179.514 162.327 190.611 154.549 204.797C146.999 218.983 143.225 234.884 143.225 252.502C143.225 271.034 149.173 285.792 161.069 296.775C173.194 307.529 190.466 312.906 212.886 312.906C227.069 312.906 240.339 310.045 252.691 304.325L266.762 232.253H317.549L297.646 331.095C285.52 340.476 271.451 347.684 255.438 352.717C239.423 357.751 222.837 360.267 205.679 360.267C181.659 360.267 160.726 355.92 142.882 347.225C125.038 338.53 111.197 326.29 101.36 310.502C91.7515 294.715 86.9473 276.526 86.9473 255.934C86.9473 228.706 93.2385 204.11 105.821 182.146C118.403 160.18 136.133 143.021 159.01 130.665C181.888 118.081 215.576 111.789 245.316 111.789Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMWhiteLogoSquare);
export default __webpack_public_path__ + "static/media/M_WHITE_LOGO_SQUARE.5bc918eec5f4bee0c6372923ab7ce2e8.svg";
export { ForwardRef as ReactComponent };